class DailyReward {

    animate(endProgress, startProgress = null, threshold = null, timeStart = null, resultTime = null) {

        let progressValue = 0;
        if(startProgress !== null) {
            $('.treasure-progress-bar')[0].style.setProperty('--progress', startProgress, 'important');
            progressValue = startProgress;
        }
        else {
            progressValue = getComputedStyle($('.treasure-progress-bar')[0]).getPropertyValue('--progress');
        }

        if(progressValue >= endProgress || endProgress >= 100) { return; }

        const interval = setInterval(() => {

            progressValue = getComputedStyle($('.treasure-progress-bar')[0]).getPropertyValue('--progress');
            if(progressValue >= endProgress - 1) {
                clearInterval(interval);
            }

            $('.treasure-progress-bar')[0].style.setProperty('--progress', Number(progressValue) + 1);
        }, 15);


        if(threshold !== null && timeStart !== null && resultTime !== null) {
        
            let time = 0;

            const textInterval = setInterval(() => {
                time++;
                $('.dailyRewardTime').text(secondsToTime((timeStart - time)));

                if(time >= resultTime) {
                    clearInterval(textInterval);
                }
                
            }, 40);


            const animatedNumberText = resultTime + " s";
            new AnimatedNumber($('.dailyRewardInfo'), "time-amount-to-add-span", animatedNumberText)
                .animate(
                    { 
                        top: "-50px",
                        right: "-45px",
                    },
                );
        }

    }

}